export const MLS_AGENTS_TAB = "mls"
export const UPLOADED_LEADS_TAB = "uploaded"

export function leadDetailsApiPath(source, id) {
  if (source === UPLOADED_LEADS_TAB) {
    return `/crm/api/uploaded-leads/${id}/`
  }
  return `/crm/api/agents/${id}/`
}

/**
 * Keep already-imported (greyed) rows below actionable ones, without
 * replacing the column the user clicked. Sorting the Candidate column
 * itself is left as a plain `imported` / `-imported`.
 */
export function leadListOrdering(serverSort) {
  const raw = String(serverSort || "").trim()
  if (!raw) {
    return "imported"
  }
  const field = raw.replace(/^-/, "")
  if (field === "imported") {
    return raw
  }
  return `imported,${raw}`
}

export function formatLeadAddress(lead) {
  if (!lead) {
    return ""
  }
  const cityStateZip = [
    lead.city,
    [lead.state, lead.zipcode].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ")
  return [lead.address, cityStateZip].filter(Boolean).join(", ")
}

export function shouldIgnoreLeadRowClick(event) {
  const { target } = event
  if (!(target instanceof Element)) {
    return false
  }
  const tag = target.tagName.toLowerCase()
  if (tag === "label" || tag === "input") {
    return true
  }
  return Boolean(
    target.closest(
      "button, a, [role='button'], .MuiIconButton-root, .MuiCheckbox-root, .MuiRating-root"
    )
  )
}
